export const DEFAULT_DEVELOPMENT_AUTH_PASSWORD = 'Code@477'
